import { useRef } from 'react';
import { Point } from '@/types';
import { PinchHandler } from '@/hooks/usePinch';

type MoveCallback = (
  delta: Point,
  first: boolean,
  last: boolean,
  dragging: boolean | undefined
) => void;

export function useMoveOrEdit(
  isConfigurationSelected: boolean,
  onMove: MoveCallback,
  onPinch: PinchHandler | undefined,
  onShowEdit?: () => void
): [MoveCallback, PinchHandler] {
  const showTextEditDialog = useRef(false);

  const moveOrEdit: MoveCallback = (delta, first, last, dragging) => {
    onMove(delta, first, last, dragging);
    if (first) {
      showTextEditDialog.current = isConfigurationSelected;
    }

    const hasMoved = delta.x !== 0 || delta.y !== 0;
    if (dragging && hasMoved) {
      showTextEditDialog.current = false;
    }

    if (last) {
      if (showTextEditDialog.current) {
        onShowEdit?.();
      }
      showTextEditDialog.current = false;
    }
  };

  const pinchOrEdit: PinchHandler = (pinchScale, rotationChange, pinchState) => {
    onPinch?.(pinchScale, rotationChange, pinchState);
    if (pinchState.pinching) {
      showTextEditDialog.current = false;
    }
  };

  return [moveOrEdit, pinchOrEdit];
}
